export const CLIENT_FLICKR_API_KEY = "fbb86c8638140bf21017510a3cb6cdcb";
